// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a big_j big_i big_bc big_r big_st","QualityCheckboxes__quality":"ex_b"};